import { GameFilterCategoriesConfig } from '../../games-filter/games-filter-categories.models';
import { gameFilterCategoriesConfig } from '../../games-filter/games-filter-categories.config';
import { RewardsModalConfig } from '../../rewards/rewards.models';

export interface ModalsState {
  gameFilterCategoriesConfig: GameFilterCategoriesConfig;
  rewardsModalConfig?: RewardsModalConfig;
  modalMenuConfig?: string;
}

export const initialState = {
  gameFilterCategoriesConfig: gameFilterCategoriesConfig
}
